// External
import React from "react";
import _ from "lodash";
import { compose, graphql } from "lib/apolloClient";
import { connect } from "react-redux";

// Internal
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

// Design system
import { EmptyState } from "@toddle-edu/ds-web";
import { NoDataIllustration } from "@toddle-edu/ds-theme";
import withLoader from "UIComponents/GqlWithLoader";
import FeedListv2 from "AppComponents/FeedListv2";

// Relative
import { getRemarkLogsQuery } from "./modules/RemarkLogsQueries";
import {
  getRemarkLogsColumnList,
  getRemarkLogsFeedData,
  getRemarkLogsQueryInput,
  getCustomComponent,
} from "./modules/RemarkLogsUtils";
import DownloadTableData from "../DownloadTableData/DownloadTableData";

// Styles
import classes from "./RemarkLogsModal.scss";

const styles = {
  emptyStateSubtitleStyle: {
    maxWidth: "448px",
  },
};

const RemarkLogsModal = ({ remarkLogsData, data, setToastMsg }) => {
  const columnList = getRemarkLogsColumnList({
    curriculumProgramType: data.curriculumProgramType,
  });
  const feedData = getRemarkLogsFeedData({
    data: remarkLogsData,
    curriculumProgramType: data.curriculumProgramType,
  });

  const getCustomComponentWrapper = props =>
    getCustomComponent({ ...props, setToastMsg });

  if (_.isEmpty(feedData)) {
    return (
      <div className={classes.emptyStateContainer}>
        <EmptyState
          title="No remark logs found"
          subtitle="There are no remark logs recorded for this progress report set yet"
          subtitleStyle={styles.emptyStateSubtitleStyle}
          illustration={NoDataIllustration}
        />
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h2 className="heading-2">Remarks Logs</h2>
        <DownloadTableData
          feedData={feedData}
          columnList={columnList}
          fileName="remark_logs"
        />
      </div>
      <div className={classes.tableContainer}>
        <FeedListv2
          columnList={columnList}
          feedData={feedData}
          enableStickyHeader={true}
          headerTheme="subtle"
          showBorder={true}
          getCustomComponent={getCustomComponentWrapper}
        />
      </div>
    </div>
  );
};

const mapActionCreators = {
  setToastMsg,
};

export default compose(
  graphql(getRemarkLogsQuery, {
    name: "getRemarkLogsQuery",
    options: ({ data }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          input: getRemarkLogsQueryInput({
            data,
          }),
        },
      };
    },
    props: ({ getRemarkLogsQuery }) => {
      const queryData = _.get(getRemarkLogsQuery, "documentation", {});
      const remarkLogsData = _.get(
        queryData,
        "internalToolsData.progressReport.remarkLogs",
        []
      );

      return {
        remarkLogsData,
        isData: !_.isEmpty(queryData),
        isLoading:
          _.get(getRemarkLogsQuery, "networkStatus") == 1 ||
          _.get(getRemarkLogsQuery, "networkStatus") == 2,
      };
    },
  }),
  connect(null, mapActionCreators),
  withLoader
)(RemarkLogsModal);
